module.exports = __webpack_public_path__ + "img/huankuan_touxiang.1cd4c443.png";